<template>
    <div class="comm_back_cla">
         <div class="container">
             <div class="button_cla" @click.stop="goBack">返回上一级</div>
             <div class="button_cla" @click.stop="goDashbord">首页</div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ZkErrorPage',
  data () {
    return {
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    goDashbord () {
      window.location.href = './app.html'
    }
  }
}
</script>
<style lang="less">
.comm_back_cla{
  width:100%;
  height:100%;
  padding: 0;
  margin: 0;
  position: absolute;
  background-size:100% 100%;
  background-size: cover;
  background:url('../../../images/404.jpg') no-repeat;
  background-position: center;
  .container{
    top: 67%;
    position: absolute;
    left: 38%;
    .button_cla {
      cursor: pointer;
      background-color: #4CAF50; /* Green */
      border: none;
      color: white;
      padding: 15px 32px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      font-size: 16px;
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
    }

    .button_cla:hover {
      box-shadow: 0 12px 16px 0 rgba(0,0,0,0.24), 0 17px 50px 0 rgba(0,0,0,0.19);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/error/src/main.vue